import React from 'react';
import { RouteProps } from 'react-router-dom';

type ScreenProps = Omit<RouteProps, 'exact'>;
export interface IRouteList {
  finish: ScreenProps;
  subscription: ScreenProps;
  payment: ScreenProps;
  signUp: ScreenProps;
}

export const RouteList: IRouteList = {
  finish: {
    component: React.lazy(() => import('../screens/FinishScreen/FinishScreen')),
    path: '/finish'
  },
  subscription: {
    component: React.lazy(() => import('../screens/SubscriptionScreen/SubscriptionScreen')),
    path: '/subscription'
  },
  payment: {
    component: React.lazy(() => import('../screens/PaymentScreen/PaymentScreen')),
    path: '/payment'
  },
  signUp: {
    component: React.lazy(() => import('../screens/SignUp/SignUpScreen')),
    path: '/'
  }
};
